import styled from 'styled-components';
import { theme } from 'kb-shared';

export const HelperText = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  ${theme.fonts.FoundersGrotesk};
  font-size: 14px;
  text-align: left;
  color: ${({ theme }) => theme.colors.night};
`;
export const FooterHelperText = styled(HelperText)`
  padding-left: 10px;
  margin-top: 12px;
  font-size: 12px;
  position: relative;
`;
export const Star = styled.span`
  position: absolute;
  left: 0;
  top: 2px;
`;
export const Link = styled.a`
  font-weight: bold;
  text-decoration: underline;
`;
